import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../../../../utils/api';
import ToastNotifications from '../../../../Components/ToastNotifications';

const MediaSosial = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [profile, setProfile] = useState({});
  const [messageNotifications, setMessage] = useState('');
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (state?.user) {
      setProfile(state.user);
    }
  }, [state?.user]);

  const onHandleSubmit = async () => {
    const payload = { ...state.user, ...profile };

    const requiredFields = {
      usernameSocmedInstagram: 'Instagram Kosong!',
      usernameSocmedTiktok: 'Tiktok Kosong!',
      usernameSocmedLinkedIn: 'LinkedIn Kosong!',
    };

    for (const [key, errorMessage] of Object.entries(requiredFields)) {
      if (!payload[key]) return alert(errorMessage);
    }

    try {
      setIsLoading(true);
      const { status, message, data } = await api.updateProfile({ payload });
      const { firstName, lastName } = data;

      if (status === 'success') {
        setMessage(`Sukses Mengubah Data ${firstName} ${lastName}`);
        setShow(true);
        setTimeout(() => navigate('/app/profile'), 2000);
      } else {
        setMessage(message);
        setShow(true);
      }
    } catch (error) {
      setMessage('Terjadi kesalahan saat menghubungi server.');
      setShow(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="py-5 text-center">
        <h2>IV. MEDIA SOSIAL</h2>
        <p className="lead">
          Bagian pendataan media sosial ini bertujuan untuk mendukung eksposur
          dan portofolio mahasiswa. Semua karya yang berkaitan dengan kegiatan
          mahasiswa akan ditag agar mahasiswa mendapat eksposur.
          Prestasi-prestasi seperti sertifikat juga akan ditag ke akun
          mahasiswa, termasuk di LinkedIn mahasiswa bisa mendapat rekomendari
          dari akun BCF dan akun Tim BCF.
        </p>
      </div>

      <div className="row g-5">
        <div className="col-md-12 col-lg-8">
          <form className="needs-validation mb-5">
            <div className="card">
              <div className="card-body">
                <div
                  class="alert alert-primary d-flex align-items-center"
                  role="alert"
                >
                  <div>
                    <p>Contoh pengisian link media sosial</p>
                    <ul>
                      <li>
                        https://www.instagram.com/bakriecenter menjadi
                        bakriecenter
                      </li>
                      <li>
                        https://www.tiktok.com/@bakriecenter menjadi
                        bakriecenter
                      </li>
                      <li>
                        https://www.linkedin.com/in/bakriecenter menjadi
                        bakriecenter
                      </li>
                    </ul>
                    <p>
                      Jika tidak mempunyai salah satu media sosial isi dengan (
                      - ) strip.
                    </p>
                    <p>
                      * Jumlah followers media sosial kamu saat ini? (Untuk
                      mendukung peluang kolaborasi dengan tim PR & Communication
                      BCF)
                    </p>
                  </div>
                </div>

                <div className="row g-3">
                  <div className="col-8">
                    <label htmlFor="address" className="form-label">
                      Username Instagram *
                    </label>
                    <input
                      onChange={(e) =>
                        setProfile({
                          ...profile,
                          usernameSocmedInstagram: e.target.value,
                        })
                      }
                      value={profile?.usernameSocmedInstagram}
                      type="text"
                      className="form-control"
                    />
                  </div>

                  <div className="col-4">
                    <label htmlFor="address" className="form-label">
                      Jumlah followers *
                    </label>
                    <input
                      onChange={(e) =>
                        setProfile({
                          ...profile,
                          followersSocmedInstagram: Number(e.target.value),
                        })
                      }
                      value={profile?.followersSocmedInstagram}
                      type="number"
                      className="form-control"
                    />
                  </div>

                  <div className="col-8">
                    <label htmlFor="address" className="form-label">
                      Username TikTok *
                    </label>
                    <input
                      onChange={(e) =>
                        setProfile({
                          ...profile,
                          usernameSocmedTiktok: e.target.value,
                        })
                      }
                      value={profile?.usernameSocmedTiktok}
                      type="text"
                      className="form-control"
                    />
                  </div>

                  <div className="col-4">
                    <label htmlFor="address" className="form-label">
                      Jumlah followers *
                    </label>
                    <input
                      onChange={(e) =>
                        setProfile({
                          ...profile,
                          followersSocmedTiktok: Number(e.target.value),
                        })
                      }
                      value={profile?.followersSocmedTiktok}
                      type="number"
                      className="form-control"
                    />
                  </div>

                  <div className="col-8">
                    <label htmlFor="address" className="form-label">
                      Username LinkedIn *
                    </label>
                    <input
                      onChange={(e) =>
                        setProfile({
                          ...profile,
                          usernameSocmedLinkedIn: e.target.value,
                        })
                      }
                      value={profile?.usernameSocmedLinkedIn}
                      type="text"
                      className="form-control"
                    />
                  </div>

                  <div className="col-4">
                    <label htmlFor="address" className="form-label">
                      Jumlah followers *
                    </label>
                    <input
                      onChange={(e) =>
                        setProfile({
                          ...profile,
                          followersSocmedLinkedIn: Number(e.target.value),
                        })
                      }
                      value={profile?.followersSocmedLinkedIn}
                      type="number"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>

            <button
              onClick={() => onHandleSubmit()}
              className="w-100 btn btn-primary btn-lg my-3"
              type="button"
            >
              {isLoading ? (
                <>
                  <span
                    class="spinner-border spinner-border-sm"
                    aria-hidden="true"
                  ></span>
                  <span class="visually-hidden" role="status">
                    Loading...
                  </span>
                </>
              ) : (
                <span>Simpan</span>
              )}
            </button>
          </form>
        </div>

        <ToastNotifications
          setShowNotifications={setShow}
          show={show}
          message={messageNotifications}
        />
      </div>
    </>
  );
};

export default MediaSosial;
